export default "__VITE_ASSET__a4d24c31__"